import { Link } from "react-router-dom";

import { Button, Container, Text, Title } from "@mantine/core";
import { IconArrowDown } from "@tabler/icons-react";

import { Typewriter } from "react-simple-typewriter";

import { AppName, Colors } from "../../../Lib/Data";

import "./styles.scss";

export default function HomeHeroSection() {
  return (
    <div className="hero-section">
      <div className={"root flex-row justify-center"}>
        <div className={"inner"}>
          <Container size="lg">
            <div className={"content"}>
              <Title className={"title"}>
                Unlock{" "}
                <Text inherit c={Colors.BlueSecondary}>
                  <Typewriter
                    words={["Premium", "Unlimited", "Cheap"]}
                    loop={false}
                    cursor={true}
                    cursorBlinking={true}
                    cursorStyle="|"
                    typeSpeed={70}
                    deleteSpeed={50}
                    delaySpeed={1000}
                  />
                </Text>{" "}
                <Text
                  inherit
                  c={Colors.GreenTertiary}
                  className="entertainment"
                >
                  Entertainment
                </Text>
                with {AppName}
              </Title>

              <Text className={"description"} mt={30} fz="lg" fw={500}>
                {AppName} brings you premium entertainment at a fraction of the
                cost. Discover, share, and enjoy the subscription revolution
                today!
              </Text>

              <div className="flex-row align-center btns">
                <Link to="/d/services">
                  <Button
                    variant="gradient"
                    className="btn primary-btn"
                    gradient={{
                      from: Colors.GreenPrimary,
                      to: Colors.BluePrimary,
                    }}
                    size="lg"
                  >
                    Get started
                  </Button>
                </Link>
                <a href="#banners">
                  <Button
                    ml={20}
                    variant="subtle"
                    c="white"
                    size="lg"
                    rightSection={<IconArrowDown />}
                    className="view-more-btn"
                  >
                    View More
                  </Button>
                </a>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
}
